import { createSlice } from '@reduxjs/toolkit';
import { fetchWorkingTimeStatistics } from '../thunks/workingTimeStatisticsThunks.js';

const initialState = {
    isLoading: false,
    maxPageNumber: 0,
    statistics: [],
    error: null,
    teams: [],
    holidays: [],
};

const workingTimeStatisticsSlice = createSlice({
    name: 'workingTimeStatistics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkingTimeStatistics.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchWorkingTimeStatistics.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.isLoading = false;
            })
            .addCase(fetchWorkingTimeStatistics.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error || action.error?.message;
            })
            .addDefaultCase((state) => state);
    },
});

export default workingTimeStatisticsSlice.reducer;
